import { render } from "./CertReward.vue?vue&type=template&id=2e6fc49e&scoped=true"
import script from "./CertReward.vue?vue&type=script&lang=js"
export * from "./CertReward.vue?vue&type=script&lang=js"

import "./CertReward.vue?vue&type=style&index=0&id=2e6fc49e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6fc49e"]])

export default __exports__